(function () {
  const page = document.querySelector('.rr-auction-page');
  if (!page) return;

  const WORKER_URL = (page.dataset.workerUrl || '').replace(/\/$/, '');
  const overlay = document.querySelector('[data-bid-modal-overlay]');
  const form = document.querySelector('[data-bid-form]');
  const errorEl = document.querySelector('[data-bid-error]');
  const successEl = document.querySelector('[data-bid-success]');
  const submitBtn = document.querySelector('[data-bid-submit-btn]');
  const modalProductName = document.querySelector('[data-modal-product-name]');
  const modalProductId = document.querySelector('[data-modal-product-id]');
  const modalCurrentBid = document.querySelector('[data-modal-current-bid]');
  const amountInput = document.querySelector('[data-bid-amount-input]');

  let activeCard = null;

  function formatMoney(n) {
    return '₹' + Number(n || 0).toLocaleString('en-IN');
  }

  function openModal(card) {
    activeCard = card;
    const title = card.querySelector('.rr-auction-product-title').textContent;
    const highest = card.querySelector('[data-highest-bid]').textContent.replace('₹', '').replace(/,/g, '');
    modalProductName.textContent = title;
    modalProductId.value = card.dataset.productId;
    modalCurrentBid.textContent = formatMoney(highest);
    amountInput.min = Number(highest) + 1;
    amountInput.value = '';
    errorEl.hidden = true;
    successEl.hidden = true;
    form.hidden = false;
    overlay.hidden = false;
  }

  function closeModal() {
    overlay.hidden = true;
    activeCard = null;
  }

  document.querySelectorAll('[data-open-bid-modal]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const card = btn.closest('.rr-auction-card');
      openModal(card);
    });
  });

  document.querySelector('[data-close-bid-modal]').addEventListener('click', closeModal);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeModal();
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.hidden = true;

    if (!WORKER_URL) {
      errorEl.textContent = 'Auction backend not configured yet.';
      errorEl.hidden = false;
      return;
    }

    const fd = new FormData(form);
    const payload = {
      product_id: fd.get('product_id'),
      name: fd.get('name').trim(),
      city: fd.get('city').trim(),
      phone: fd.get('phone').trim(),
      amount: Number(fd.get('amount')),
    };

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';

    try {
      const res = await fetch(`${WORKER_URL}?product_id=${encodeURIComponent(payload.product_id)}&name=${encodeURIComponent(payload.name)}&city=${encodeURIComponent(payload.city)}&phone=${encodeURIComponent(payload.phone)}&amount=${encodeURIComponent(payload.amount)}`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (!res.ok || !data.success) {
        errorEl.textContent = data.error || 'Your bid could not be placed. Try a higher amount.';
        errorEl.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Bid';
        return;
      }

      // update the card in the background
      if (activeCard) {
        activeCard.querySelector('[data-highest-bid]').textContent = formatMoney(data.highest);
        activeCard.querySelector('[data-bidder-count]').textContent = data.count;
      }

      form.hidden = true;
      successEl.hidden = false;
      setTimeout(closeModal, 2200);
    } catch (err) {
      errorEl.textContent = 'Network error. Please try again.';
      errorEl.hidden = false;
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Submit Bid';
    }
  });

  // ---- Load current stats for each product on page load ----
  async function loadStats() {
    if (!WORKER_URL) return;
    const cards = document.querySelectorAll('.rr-auction-card');
    for (const card of cards) {
      try {
        const res = await fetch(`${WORKER_URL}?product_id=${encodeURIComponent(card.dataset.productId)}`);
        if (!res.ok) continue;
        const data = await res.json();
        const highest = Math.max(data.highest || 0, Number(card.dataset.startingBid) || 0);
        card.querySelector('[data-highest-bid]').textContent = formatMoney(highest);
        card.querySelector('[data-bidder-count]').textContent = data.count || 0;
      } catch (e) {
        // fail silently per card, keep starting bid shown
      }
    }
  }
  loadStats();

  // ---- Countdown timers ----
  function pad(n) { return String(n).padStart(2, '0'); }

  function tickTimers() {
    document.querySelectorAll('.rr-auction-card').forEach((card) => {
      const endStr = card.dataset.endDate;
      const badge = card.querySelector('[data-timer-badge]');
      const textEl = card.querySelector('[data-timer-text]');
      const bidBtn = card.querySelector('[data-open-bid-modal]');
      if (!endStr) {
        textEl.textContent = 'No end date';
        return;
      }
      const end = new Date(endStr).getTime();
      const now = Date.now();
      const diff = end - now;

      if (diff <= 0) {
        textEl.textContent = 'Auction Ended';
        badge.classList.add('rr-ended');
        if (bidBtn) bidBtn.disabled = true;
        return;
      }

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);
      textEl.textContent = `${d}d ${pad(h)}:${pad(m)}:${pad(s)}`;
    });
  }
  tickTimers();
  setInterval(tickTimers, 1000);

  // refresh live stats periodically so bidders see updates without reloading
  setInterval(loadStats, 20000);
})();
